import { render } from "./PageInNav.vue?vue&type=template&id=03fed0fc&scoped=true"
import script from "./PageInNav.vue?vue&type=script&lang=js"
export * from "./PageInNav.vue?vue&type=script&lang=js"

import "./PageInNav.vue?vue&type=style&index=0&id=03fed0fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fed0fc"]])

export default __exports__